/* eslint-disable react/display-name */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';

import {
  SearchFacetType,
  SuggestionItemProp,
  DetailsControlProps
} from '../type';
import LabelFacetDetails from '../LabelFacetDetails';
import LabelOptionItem from '../OptionItem';
import { clientTag } from './tag';
import makeCriteriaProvider from './makeCriteriaProvider';
import { useClientLabelSearch } from './hooks/useClientLabelSearch';
import ClientIcon from './ClientIcon';

const icon = <ClientIcon />;
const noClientsMessage = <FormattedMessage id="search.facets.noClient" />;

export const getDetailsControl = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingDopDownValue?: (label: any, setSelected: any) => void
): React.FC<DetailsControlProps> => ({
  selected,
  setSelected
}: DetailsControlProps) => {
  const { options, loading, searchHandler, hasMore } = useClientLabelSearch();

  return (
    <LabelFacetDetails
      selected={selected}
      setSelected={setSelected}
      options={options}
      loading={loading}
      searchHandler={searchHandler}
      label={label}
      icon={icon}
      noOptionsText={noClientsMessage}
      hasMore={hasMore}
      onDropdownValueChange={onDropdownValueChange}
      isDisable={isDisable}
      settingDopDownValue={settingDopDownValue}
    />
  );
};

const SuggestionItem: React.FC<SuggestionItemProp> = ({
  option
}: SuggestionItemProp) => (
  <LabelOptionItem testId={option.id} value={option.label} icon={icon} />
);

export const getClientFacet = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingDopDownValue?: (label: any, setSelected: any) => void
): SearchFacetType => ({
  makeCriteriaProvider: makeCriteriaProvider(label),
  tag: clientTag,
  DetailsControl: getDetailsControl(
    label,
    onDropdownValueChange,
    isDisable,
    settingDopDownValue
  ),
  SuggestionItem: SuggestionItem
});

export default getClientFacet;
